// extracted by mini-css-extract-plugin
export var registrationDone = "RegistrationDone-module--registrationDone--2_D1W";
export var registrationDone__icon = "RegistrationDone-module--registrationDone__icon--2m9Dg";
export var registrationDone__title = "RegistrationDone-module--registrationDone__title--3pNB0";
export var registrationDone__subtitle = "RegistrationDone-module--registrationDone__subtitle--2pYcK";
export var registrationDone__mail_title = "RegistrationDone-module--registrationDone__mail_title--1Osw8";
export var registrationDone__mail_button = "RegistrationDone-module--registrationDone__mail_button--2whiP";